<template>
  <div>
    <v-card
      :style="`
      border: ${border_px}px solid ${border_color};
      `"
      flat
      tile
      :color="bgcolor"
      class="pb-3"
    >
      <v-card-text v-for="(button, i) in data.conditionsAnswer.match" :key="i">
        <v-row class="pt-3">
          <v-col
            class="py-0 pt-3"
            :cols="checkbox_row ? 3 : 12"
            v-for="(choice, c) in button.choice"
            :key="c"
          >
            <div class="d-flex align-start">
              <v-checkbox
                v-model="choice.selected"
                :disabled="AllowCheckbox(i, c)"
                :color="color"
                style="white-space: pre-line"
                hide-details
                class="mt-0"
              >
                <template #label></template>
              </v-checkbox>
              <span
                class="mt-1"
                :style="`color:${color_text};font-size: 18px;word-break: break-word;`"
                >{{ choice.text }}</span
              >
            </div>
            <v-text-field
              v-if="choice.selected && choice.description"
              v-model="choice.detail"
              label="รายละเอียด"
              :color="color"
              :rules="[
                choice.selected ? $store.getters.TextRule(choice.detail) : true,
              ]"
              v-show="false"
            ></v-text-field>
            <v-text-field
              v-if="choice.selected && choice.description"
              v-model="choice.detail"
              placeholder="รายละเอียด"
              :color="color"
              :rules="[
                choice.selected ? $store.getters.TextRule(choice.detail) : true,
              ]"
              style="font-size: 18px; margin-top: -10px; margin-left: 32px"
              @keyup.enter="EnterSend"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="min === 1" flat tile class="font-italic subheading py-2">
      *เลือกได้ไม่เกิน {{ max }} ตัวเลือก
    </v-card>
    <v-card
      v-else-if="min === max"
      flat
      tile
      class="font-italic subheading py-2"
    >
      *ต้องเลือกทั้งหมด {{ min }} ตัวเลือก
    </v-card>
    <v-card v-else flat tile class="font-italic subheading py-2">
      *เลือกอย่างน้อย {{ min }} แต่ไม่เกิน {{ max }} ตัวเลือก
    </v-card>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "min",
    "max",
    "checkbox_row",
    "bgcolor",
    "color",
    "color_text",
    "border_px",
    "border_color",
  ],
  data() {
    return {};
  },
  methods: {
    AllowCheckbox(i, c) {
      let checkbox = this.data.conditionsAnswer.match[i].choice[c];
      let selected = this.data.conditionsAnswer.match[i].choice.filter(
        (s) => s.selected
      ).length;
      if (selected >= this.max) {
        return !checkbox.selected;
      }
      return false;
    },
    EnterSend() {
      this.$emit("SendByEnter");
    },
    setAns(ans) {
      console.log(ans);
    },
  },
};
</script>

<style lang="scss" scoped></style>
